import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Copy } from "lucide-react";
import { useState } from "react";

export const CompleteOrganizationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [copied, setCopied] = useState<string>();

  // stateが無い場合は組織登録ページにリダイレクト
  if (!location.state?.email || !location.state?.password) {
    navigate("/paradis/organization/new");
    return null;
  }

  const { email, password } = location.state;

  const handleCopy = async (text: string, label: string) => {
    await navigator.clipboard.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(undefined), 2000);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 600, mx: 2 }}>
        <CardContent>
          <Typography variant="h5" component="h1" gutterBottom textAlign="center">
            組織登録完了
          </Typography>

          <Alert severity="success" sx={{ mb: 4 }}>
            組織の登録が完了しました
          </Alert>

          <Stack spacing={4}>
            <Box>
              <Typography variant="h6" gutterBottom>
                管理者情報
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                以下の情報を保存してください
              </Typography>

              <Stack spacing={2}>
                <Box>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    メールアドレス
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      value={email}
                      fullWidth
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <Button
                      variant="outlined"
                      onClick={() => handleCopy(email, "email")}
                      startIcon={<Copy size={16} />}
                    >
                      {copied === "email" ? "コピー完了" : "コピー"}
                    </Button>
                  </Stack>
                </Box>

                <Box>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    パスワード
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      value={password}
                      fullWidth
                      size="small"
                      type="text"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <Button
                      variant="outlined"
                      onClick={() => handleCopy(password, "password")}
                      startIcon={<Copy size={16} />}
                    >
                      {copied === "password" ? "コピー完了" : "コピー"}
                    </Button>
                  </Stack>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};
